import { Task } from "@/types";

export function getShortenedTaskText(task: Task) {
  const taskText = task.description || "";
  if (taskText.length > 20) return taskText.slice(0, 20).trim() + "...";
  return taskText;
}
